const meta = {
    'meta.name': 'Nederlands',
    'meta.short': 'nl_NL',
};

export default meta;
